<template>
  <div class="container">
    <!-- Loader Screen -->
    <div v-if="loading" class="loader-screen">
      <img src="https://assets.codepen.io/11151897/cat-black.gif" alt="Loading..." />
    </div>
  <div class="container">
    <!-- Chip Selector -->
    <div class="chip-selector">
      <span 
        v-for="keyword in allKeywords" 
        :key="keyword" 
        class="chip" 
        @click="selectKeyword(keyword)"
        :class="{ selected: selectedKeyword === keyword }"
      >
        {{ keyword }}
      </span>
    </div>

    <!-- Video List -->
    <div v-for="video in limitedFilteredVideos" :key="video.Subject" class="video-card">
      <iframe :src="video.Url" frameborder="0" class="video-frame"></iframe>
      <div class="info-box">
        <h3>{{ video.Subject }}</h3>
        <p class="creator">{{ video.Creator }}</p>
        <div class="chips">
          <span v-for="keyword in video.Keyword.split(',')" :key="keyword" class="chip">
            {{ keyword.trim() }}
          </span>
        </div>
      </div>
    </div>
  </div></div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import axios from 'axios';

const videos = ref([]);
const selectedKeyword = ref('');
const page = ref(1);
const videosPerPage = ref(10); // Number of videos per page
const loading = ref(true); // Initial loading state
const loadVideos = async (page) => {
  try {
    const { data } = await axios.get(`https://farahk.pythonanywhere.com/api/media_video_list/?page=${page}`);
    const newVideos = data.media.map(video => {
      if (video.Url) {
        const videoID = video.Url.split("https://youtu.be/")[1];
        video.Url = `https://www.youtube.com/embed/${videoID}`;
        return video;
      } else {
        console.warn('Video URL is null for video: ', video.Subject);
        return video;
      }
    });
    videos.value = [...videos.value, ...newVideos];
    loading.value = false; // Update loading state
  } catch (error) {
    console.error("Failed to load videos: ", error);
    loading.value = false; // Ensure loading state is updated even if there's an error
  }
};

const allKeywords = computed(() => {
  const keywordsSet = new Set();
  videos.value.forEach(video => {
    video.Keyword.split(',').forEach(k => keywordsSet.add(k.trim()));
  });
  return Array.from(keywordsSet);
});

const filteredVideos = computed(() => {
  if (!selectedKeyword.value) return videos.value;
  const uniqueSubjects = new Set();
  const filtered = [];
  
  videos.value.forEach(video => {
    const keywords = video.Keyword.split(',').map(k => k.trim());
    if (keywords.includes(selectedKeyword.value) && !uniqueSubjects.has(video.Subject)) {
      uniqueSubjects.add(video.Subject);
      filtered.push(video);
    }
  });
  
  return filtered;
});

// Only show videos up to the limit
const limitedFilteredVideos = computed(() => {
  return filteredVideos.value.slice(0, page.value * videosPerPage.value);
});

const selectKeyword = (keyword) => {
  selectedKeyword.value = keyword;
};

const handleScroll = () => {
  const nearBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500;
  if (nearBottom) {
    page.value += 1;
    loadVideos(page.value);
  }
};

onMounted(() => {
  loadVideos(page.value);
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

</script>



<style scoped>

html, body {
  height: 100%;
  margin: 0;
}
.container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}
.loader-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9); /* Light background to make the gif visible */
  z-index: 1000; /* Ensure it's above other content */
}
.video-card {
  width: 300px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  overflow: hidden;
  background: white;
}

.video-frame {
  width: 100%;
  height: 220px;
}

.info-box {
  padding: 10px;
  text-align: left;
}

.creator {
  font-weight: bold;
  color: #333;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  background-color: #f1f1f1;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
}

.chip-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.chip.selected {
  background-color: #4A148C;
  color: white;
}
</style>









